"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UBER_TRACE_ID_HEADER = exports.UBER_BAGGAGE_HEADER_PREFIX = exports.JaegerPropagator = void 0;
var JaegerPropagator_1 = require("./JaegerPropagator");
Object.defineProperty(exports, "JaegerPropagator", { enumerable: true, get: function () { return JaegerPropagator_1.JaegerPropagator; } });
Object.defineProperty(exports, "UBER_BAGGAGE_HEADER_PREFIX", { enumerable: true, get: function () { return JaegerPropagator_1.UBER_BAGGAGE_HEADER_PREFIX; } });
Object.defineProperty(exports, "UBER_TRACE_ID_HEADER", { enumerable: true, get: function () { return JaegerPropagator_1.UBER_TRACE_ID_HEADER; } });
//# sourceMappingURL=index.js.map